import { Injectable } from '@angular/core';

import { WebviewService } from './webview.service';

@Injectable({
  providedIn: 'root',
})
export class BrowserWebviewService extends WebviewService {
  private readonly log = 'ERROR: Webview not detected';

  public closeWebView(): void {}

  public openContact(): void {}
}
